import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LinearProgress } from "@mui/material";

import "./Home.css";
import { useAppDispatch } from "../../state/hooks";
import { RootState } from "../../state/store";
import { setCurrentView } from "../../state/reducers/viewReducer";
import useShiftTimes from "../../components/Hooks/useShiftTimes";
import { DashboardHeader } from "../../components/Dashboard/DashboardHeader";
import { DashboardKpiStrip } from "../../components/Dashboard/DashboardKpiStrip";
import { DashboardQuickTiles } from "../../components/Dashboard/DashboardQuickTiles";
import { DashboardGrid } from "../../components/Dashboard/DashboardGrid";

const Home: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentView = useSelector((state: RootState) => state.view.currentView);
  const { selectedDate } = useShiftTimes();
  const rehydrated = useSelector((s: RootState) => s?._persist?.rehydrated === true);

  useEffect(() => {
    if (rehydrated && currentView !== "Home") {
      dispatch(setCurrentView("Home"));
    }
  }, [currentView, dispatch, rehydrated]);

  if (!rehydrated || !selectedDate) {
    return <LinearProgress className="w-full" />;
  }

  return (
    <>
      <DashboardHeader />
      <div className="flex-grow py-8 sm:px-4 md:px-8 flex flex-col gap-6 md:gap-8 items-center mx-auto w-full 2xl:max-w-[2180px]">
        <DashboardKpiStrip />
        <DashboardQuickTiles />
        <DashboardGrid />
      </div>
    </>
  );
};

export default Home;
